<template>
  <form @submit.prevent="handleSubmit(item)">
    <div class="form-group">
      <label
        for="exsbinvoiceposition_createdAt"
        class="form-control-label">createdAt</label>
      <input
        id="exsbinvoiceposition_createdAt"
        v-model="item.createdAt"
        :class="['form-control', isInvalid('createdAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('createdAt', $event.target.value)">
      <div
        v-if="isInvalid('createdAt')"
        class="invalid-feedback">{{ violations.createdAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_updatedAt"
        class="form-control-label">updatedAt</label>
      <input
        id="exsbinvoiceposition_updatedAt"
        v-model="item.updatedAt"
        :class="['form-control', isInvalid('updatedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('updatedAt', $event.target.value)">
      <div
        v-if="isInvalid('updatedAt')"
        class="invalid-feedback">{{ violations.updatedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_deletedAt"
        class="form-control-label">deletedAt</label>
      <input
        id="exsbinvoiceposition_deletedAt"
        v-model="item.deletedAt"
        :class="['form-control', isInvalid('deletedAt') ? 'is-invalid' : '']"
        type="dateTime"
        placeholder=""
        @input="handleUpdateField('deletedAt', $event.target.value)">
      <div
        v-if="isInvalid('deletedAt')"
        class="invalid-feedback">{{ violations.deletedAt }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_createdBy"
        class="form-control-label">createdBy</label>
      <input
        id="exsbinvoiceposition_createdBy"
        v-model="item.createdBy"
        :class="['form-control', isInvalid('createdBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('createdBy', $event.target.value)">
      <div
        v-if="isInvalid('createdBy')"
        class="invalid-feedback">{{ violations.createdBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_updatedBy"
        class="form-control-label">updatedBy</label>
      <input
        id="exsbinvoiceposition_updatedBy"
        v-model="item.updatedBy"
        :class="['form-control', isInvalid('updatedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('updatedBy', $event.target.value)">
      <div
        v-if="isInvalid('updatedBy')"
        class="invalid-feedback">{{ violations.updatedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_deletedBy"
        class="form-control-label">deletedBy</label>
      <input
        id="exsbinvoiceposition_deletedBy"
        v-model="item.deletedBy"
        :class="['form-control', isInvalid('deletedBy') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('deletedBy', $event.target.value)">
      <div
        v-if="isInvalid('deletedBy')"
        class="invalid-feedback">{{ violations.deletedBy }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_state"
        class="form-control-label">state</label>
      <input
        id="exsbinvoiceposition_state"
        v-model="item.state"
        :class="['form-control', isInvalid('state') ? 'is-invalid' : '']"
        type="number"
        placeholder=""
        @input="handleUpdateField('state', $event.target.value)">
      <div
        v-if="isInvalid('state')"
        class="invalid-feedback">{{ violations.state }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_invoice"
        class="form-control-label">invoice</label>
      <input
        id="exsbinvoiceposition_invoice"
        v-model="item.invoice"
        :class="['form-control', isInvalid('invoice') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('invoice', $event.target.value)">
      <div
        v-if="isInvalid('invoice')"
        class="invalid-feedback">{{ violations.invoice }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_item"
        class="form-control-label">item</label>
      <input
        id="exsbinvoiceposition_item"
        v-model="item.item"
        :class="['form-control', isInvalid('item') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('item', $event.target.value)">
      <div
        v-if="isInvalid('item')"
        class="invalid-feedback">{{ violations.item }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_customItem"
        class="form-control-label">customItem</label>
      <input
        id="exsbinvoiceposition_customItem"
        v-model="item.customItem"
        :class="['form-control', isInvalid('customItem') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('customItem', $event.target.value)">
      <div
        v-if="isInvalid('customItem')"
        class="invalid-feedback">{{ violations.customItem }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_measure"
        class="form-control-label">measure</label>
      <input
        id="exsbinvoiceposition_measure"
        v-model="item.measure"
        :class="['form-control', isInvalid('measure') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('measure', $event.target.value)">
      <div
        v-if="isInvalid('measure')"
        class="invalid-feedback">{{ violations.measure }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_quantity"
        class="form-control-label">quantity</label>
      <input
        id="exsbinvoiceposition_quantity"
        v-model="item.quantity"
        :class="['form-control', isInvalid('quantity') ? 'is-invalid' : '']"
        type="number"
        step="0.1"
        required="true"
        placeholder=""
        @input="handleUpdateField('quantity', $event.target.value)">
      <div
        v-if="isInvalid('quantity')"
        class="invalid-feedback">{{ violations.quantity }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_priceNettoPerUnit"
        class="form-control-label">priceNettoPerUnit</label>
      <input
        id="exsbinvoiceposition_priceNettoPerUnit"
        v-model="item.priceNettoPerUnit"
        :class="['form-control', isInvalid('priceNettoPerUnit') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('priceNettoPerUnit', $event.target.value)">
      <div
        v-if="isInvalid('priceNettoPerUnit')"
        class="invalid-feedback">{{ violations.priceNettoPerUnit }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_priceNetto"
        class="form-control-label">priceNetto</label>
      <input
        id="exsbinvoiceposition_priceNetto"
        v-model="item.priceNetto"
        :class="['form-control', isInvalid('priceNetto') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('priceNetto', $event.target.value)">
      <div
        v-if="isInvalid('priceNetto')"
        class="invalid-feedback">{{ violations.priceNetto }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_vatRate"
        class="form-control-label">vatRate</label>
      <input
        id="exsbinvoiceposition_vatRate"
        v-model="item.vatRate"
        :class="['form-control', isInvalid('vatRate') ? 'is-invalid' : '']"
        type="text"
        placeholder=""
        @input="handleUpdateField('vatRate', $event.target.value)">
      <div
        v-if="isInvalid('vatRate')"
        class="invalid-feedback">{{ violations.vatRate }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_vatAmount"
        class="form-control-label">vatAmount</label>
      <input
        id="exsbinvoiceposition_vatAmount"
        v-model="item.vatAmount"
        :class="['form-control', isInvalid('vatAmount') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('vatAmount', $event.target.value)">
      <div
        v-if="isInvalid('vatAmount')"
        class="invalid-feedback">{{ violations.vatAmount }}</div>
    </div>
    <div class="form-group">
      <label
        for="exsbinvoiceposition_priceBrutto"
        class="form-control-label">priceBrutto</label>
      <input
        id="exsbinvoiceposition_priceBrutto"
        v-model="item.priceBrutto"
        :class="['form-control', isInvalid('priceBrutto') ? 'is-invalid' : '']"
        type="text"
        required="true"
        placeholder=""
        @input="handleUpdateField('priceBrutto', $event.target.value)">
      <div
        v-if="isInvalid('priceBrutto')"
        class="invalid-feedback">{{ violations.priceBrutto }}</div>
    </div>

    <button
      type="submit"
      class="btn btn-primary">Submit</button>
  </form>
</template>

<script>
export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  computed: {
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  methods: {
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
